import {
  setSelectedMenu,
  setSelectedMenuId,
} from "../../redux/features/appData";
import "../../css/Icons.css";
import "../../index.css";
import "./CollectionResourcesZero.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { MENUS } from "../config/menus";
import { sign } from "crypto";

type CollectionsResourcesZeroProps = {};

export const CollectionResourcesZero = ({}: CollectionsResourcesZeroProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <div
      className="collection-resources-zero"
      onClick={() => {
        dispatch(setSelectedMenu(MENUS.CONFIGURE));
        dispatch(setSelectedMenuId(null));
        navigate("/waz/kb/create");
      }}>
      <div className="collection-resources-zero-header">Add a Resource</div>

      <div className="collection-resources-zero-icon light-mode">
        <img className="icon-plus" alt="" />
      </div>
    </div>
  );
};
